import * as coreClient from "@azure/core-client";

export const BasketItemRequest: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "BasketItemRequest",
    modelProperties: {
      ticketID: {
        serializedName: "ticketID",
        required: true,
        type: {
          name: "Number"
        }
      },
      itemPrice: {
        serializedName: "itemPrice",
        required: true,
        type: {
          name: "Number"
        }
      },
      quantity: {
        serializedName: "quantity",
        required: true,
        type: {
          name: "Number"
        }
      },
      paymentMethodType: {
        serializedName: "paymentMethodType",
        required: true,
        type: {
          name: "String"
        }
      }
    }
  }
};

export const Basket: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "Basket",
    modelProperties: {
      basketId: {
        serializedName: "basketId",
        required: true,
        type: {
          name: "String"
        }
      },
      totalItems: {
        serializedName: "totalItems",
        required: true,
        type: {
          name: "Number"
        }
      },
      basketTotal: {
        serializedName: "basketTotal",
        required: true,
        type: {
          name: "Number"
        }
      },
      toPayBasketTotal: {
        serializedName: "toPayBasketTotal",
        required: true,
        type: {
          name: "Number"
        }
      },
      currency: {
        serializedName: "currency",
        type: {
          name: "String"
        }
      },
      basketItems: {
        serializedName: "basketItems",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "BasketItem"
            }
          }
        }
      },
      discount: {
        serializedName: "discount",
        type: {
          name: "Composite",
          className: "BasketDiscount"
        }
      }
    }
  }
};

export const BasketItem: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "BasketItem",
    modelProperties: {
      ticketID: {
        serializedName: "ticketID",
        required: true,
        type: {
          name: "Number"
        }
      },
      ticketDescription: {
        serializedName: "ticketDescription",
        type: {
          name: "String"
        }
      },
      itemPrice: {
        serializedName: "itemPrice",
        required: true,
        type: {
          name: "Number"
        }
      },
      quantity: {
        serializedName: "quantity",
        required: true,
        type: {
          name: "Number"
        }
      },
      price: {
        serializedName: "price",
        type: {
          name: "Number"
        }
      },
      subTotalPrice: {
        serializedName: "subTotalPrice",
        required: true,
        type: {
          name: "Number"
        }
      },
      toPayPrice: {
        serializedName: "toPayPrice",
        required: true,
        type: {
          name: "Number"
        }
      },
      paymentMethodType: {
        serializedName: "paymentMethodType",
        required: true,
        type: {
          name: "String"
        }
      },
      ticketPeriodName: {
        serializedName: "ticketPeriodName",
        type: {
          name: "String"
        }
      },
      isDirectDebit: {
        serializedName: "isDirectDebit",
        type: {
          name: "Boolean"
        }
      },
      noOfDays: {
        serializedName: "noOfDays",
        type: {
          name: "Number"
        }
      },
      pricePerDay: {
        serializedName: "pricePerDay",
        type: {
          name: "Number"
        }
      },
      minAgeBand: {
        serializedName: "minAgeBand",
        type: {
          name: "Number"
        }
      },
      maxAgeBand: {
        serializedName: "maxAgeBand",
        type: {
          name: "Number"
        }
      }
    }
  }
};

export const BasketDiscount: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "BasketDiscount",
    modelProperties: {
      voucherCode: {
        serializedName: "voucherCode",
        required: true,
        type: {
          name: "String"
        }
      },
      totalDiscountValue: {
        serializedName: "totalDiscountValue",
        required: true,
        type: {
          name: "Number"
        }
      },
      discountLabel: {
        serializedName: "discountLabel",
        required: true,
        type: {
          name: "String"
        }
      },
      accepted: {
        serializedName: "accepted",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "VoucherCodeDiscountAccepted"
            }
          }
        }
      },
      discountRejectedReason: {
        serializedName: "discountRejectedReason",
        type: {
          name: "String"
        }
      }
    }
  }
};

export const VoucherCodeDiscountAccepted: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "VoucherCodeDiscountAccepted",
    modelProperties: {
      ticketID: {
        serializedName: "ticketID",
        required: true,
        type: {
          name: "Number"
        }
      },
      discountValue: {
        serializedName: "discountValue",
        required: true,
        type: {
          name: "Number"
        }
      }
    }
  }
};

export const ApiError: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "ApiError",
    modelProperties: {
      code: {
        serializedName: "code",
        type: {
          name: "Number"
        }
      },
      shortDescription: {
        serializedName: "shortDescription",
        type: {
          name: "String"
        }
      },
      description: {
        serializedName: "description",
        type: {
          name: "String"
        }
      }
    }
  }
};

export const BasketDeleteResponse: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "BasketDeleteResponse",
    modelProperties: {
      message: {
        serializedName: "message",
        type: {
          name: "String"
        }
      }
    }
  }
};

export const BasketItemUpdateRequest: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "BasketItemUpdateRequest",
    modelProperties: {
      itemPrice: {
        serializedName: "itemPrice",
        required: true,
        type: {
          name: "Number"
        }
      },
      quantity: {
        serializedName: "quantity",
        required: true,
        type: {
          name: "Number"
        }
      },
      paymentMethodType: {
        serializedName: "paymentMethodType",
        required: true,
        type: {
          name: "String"
        }
      }
    }
  }
};

export const BasketCheckoutRequest: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "BasketCheckoutRequest",
    modelProperties: {
      applicants: {
        serializedName: "applicants",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "Applicant"
            }
          }
        }
      },
      billingCustomer: {
        serializedName: "billingCustomer",
        type: {
          name: "Composite",
          className: "BillingCustomer"
        }
      },
      billingAddress: {
        serializedName: "billingAddress",
        type: {
          name: "Composite",
          className: "Address"
        }
      },
      directDebit: {
        serializedName: "directDebit",
        type: {
          name: "Composite",
          className: "DirectDebit"
        }
      },
      preferences: {
        serializedName: "preferences",
        type: {
          name: "Composite",
          className: "CheckoutPreferences"
        }
      },
      tandc: {
        serializedName: "tandc",
        type: {
          name: "Composite",
          className: "TermsAndConditions"
        }
      },
      redirectURLs: {
        serializedName: "redirectURLs",
        type: {
          name: "Composite",
          className: "NotificationRedirect"
        }
      }
    }
  }
};

export const Applicant: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "Applicant",
    modelProperties: {
      ticketFor: {
        serializedName: "ticketFor",
        required: true,
        type: {
          name: "String"
        }
      },
      basketItemTicketID: {
        serializedName: "basketItemTicketID",
        required: true,
        type: {
          name: "String"
        }
      },
      basketItemQuantityIndex: {
        serializedName: "basketItemQuantityIndex",
        required: true,
        type: {
          name: "Number"
        }
      },
      ticketCode: {
        serializedName: "ticketCode",
        type: {
          name: "String"
        }
      },
      fulfillmentMethod: {
        serializedName: "fulfillmentMethod",
        required: true,
        type: {
          name: "String"
        }
      },
      travellingCustomer: {
        serializedName: "travellingCustomer",
        type: {
          name: "Composite",
          className: "TravellingCustomer"
        }
      },
      swiftCard: {
        serializedName: "swiftCard",
        type: {
          name: "Composite",
          className: "SwiftCardInfo"
        }
      },
      mTicket: {
        serializedName: "mTicket",
        type: {
          name: "Composite",
          className: "MTicket"
        }
      },
      student: {
        serializedName: "student",
        type: {
          name: "Composite",
          className: "StudentInfo"
        }
      },
      occupation: {
        serializedName: "occupation",
        type: {
          name: "Composite",
          className: "OccupationInfo"
        }
      }
    }
  }
};

export const TravellingCustomer: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "TravellingCustomer",
    modelProperties: {
      id: {
        serializedName: "id",
        type: {
          name: "String"
        }
      },
      firstName: {
        serializedName: "firstName",
        required: true,
        type: {
          name: "String"
        }
      },
      lastName: {
        serializedName: "lastName",
        required: true,
        type: {
          name: "String"
        }
      },
      dateOfBirth: {
        serializedName: "dateOfBirth",
        required: true,
        type: {
          name: "String"
        }
      }
    }
  }
};

export const SwiftCardInfo: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "SwiftCardInfo",
    modelProperties: {
      state: {
        serializedName: "state",
        required: true,
        type: {
          name: "String"
        }
      },
      cardNumber: {
        serializedName: "cardNumber",
        type: {
          name: "String"
        }
      },
      activationDate: {
        serializedName: "activationDate",
        required: true,
        type: {
          name: "String"
        }
      },
      newCardDeliveryAddress: {
        serializedName: "newCardDeliveryAddress",
        type: {
          name: "Composite",
          className: "Address"
        }
      }
    }
  }
};

export const Address: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "Address",
    modelProperties: {
      address1: {
        serializedName: "address1",
        required: true,
        type: {
          name: "String"
        }
      },
      address2: {
        serializedName: "address2",
        nullable: true,
        type: {
          name: "String"
        }
      },
      town: {
        serializedName: "town",
        required: true,
        type: {
          name: "String"
        }
      },
      postCode: {
        serializedName: "postCode",
        required: true,
        type: {
          name: "String"
        }
      }
    }
  }
};

export const MTicket: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "MTicket",
    modelProperties: {
      mobileNumber: {
        serializedName: "mobileNumber",
        required: true,
        type: {
          name: "String"
        }
      },
      emailAddress: {
        serializedName: "emailAddress",
        required: true,
        type: {
          name: "String"
        }
      },
      startDate: {
        serializedName: "startDate",
        required: true,
        type: {
          name: "String"
        }
      }
    }
  }
};

export const StudentInfo: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "StudentInfo",
    modelProperties: {
      studentId: {
        serializedName: "studentId",
        required: true,
        type: {
          name: "String"
        }
      },
      institution: {
        serializedName: "institution",
        required: true,
        type: {
          name: "String"
        }
      },
      course: {
        serializedName: "course",
        required: true,
        type: {
          name: "String"
        }
      },
      courseEndDate: {
        serializedName: "courseEndDate",
        required: true,
        type: {
          name: "String"
        }
      }
    }
  }
};

export const OccupationInfo: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "OccupationInfo",
    modelProperties: {
      occupationType: {
        serializedName: "occupationType",
        required: true,
        type: {
          name: "String"
        }
      },
      providerName: {
        serializedName: "providerName",
        required: true,
        type: {
          name: "String"
        }
      },
      providerAddress: {
        serializedName: "providerAddress",
        type: {
          name: "Composite",
          className: "Address"
        }
      }
    }
  }
};

export const BillingCustomer: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "BillingCustomer",
    modelProperties: {
      firstName: {
        serializedName: "firstName",
        required: true,
        type: {
          name: "String"
        }
      },
      lastName: {
        serializedName: "lastName",
        required: true,
        type: {
          name: "String"
        }
      },
      dateOfBirth: {
        serializedName: "dateOfBirth",
        required: true,
        type: {
          name: "String"
        }
      },
      mobileNumber: {
        serializedName: "mobileNumber",
        required: true,
        type: {
          name: "String"
        }
      },
      emailAddress: {
        serializedName: "emailAddress",
        required: true,
        type: {
          name: "String"
        }
      }
    }
  }
};

export const DirectDebit: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "DirectDebit",
    modelProperties: {
      fullName: {
        serializedName: "fullName",
        required: true,
        type: {
          name: "String"
        }
      },
      sortCode: {
        serializedName: "sortCode",
        required: true,
        type: {
          name: "String"
        }
      },
      accountNumber: {
        serializedName: "accountNumber",
        required: true,
        type: {
          name: "String"
        }
      },
      bankName: {
        serializedName: "bankName",
        required: true,
        type: {
          name: "String"
        }
      },
      branchName: {
        serializedName: "branchName",
        required: true,
        type: {
          name: "String"
        }
      },
      accountVerified: {
        serializedName: "accountVerified",
        required: true,
        type: {
          name: "Boolean"
        }
      },
      accountHolderMandate: {
        serializedName: "accountHolderMandate",
        type: {
          name: "Boolean"
        }
      },
      creditCheckAgreement: {
        serializedName: "creditCheckAgreement",
        type: {
          name: "Boolean"
        }
      }
    }
  }
};

export const CheckoutPreferences: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "CheckoutPreferences",
    modelProperties: {
      upcomingOffers: {
        serializedName: "upcomingOffers",
        required: true,
        type: {
          name: "Boolean"
        }
      }
    }
  }
};

export const TermsAndConditions: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "TermsAndConditions",
    modelProperties: {
      acceptTerms: {
        serializedName: "acceptTerms",
        required: true,
        type: {
          name: "Boolean"
        }
      },
      guardianConsent: {
        serializedName: "guardianConsent",
        nullable: true,
        type: {
          name: "Boolean"
        }
      }
    }
  }
};

export const NotificationRedirect: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "NotificationRedirect",
    modelProperties: {
      successURL: {
        serializedName: "successURL",
        type: {
          name: "String"
        }
      },
      errorURL: {
        serializedName: "errorURL",
        type: {
          name: "String"
        }
      }
    }
  }
};

export const BasketCheckoutResponse: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "BasketCheckoutResponse",
    modelProperties: {
      basketId: {
        serializedName: "basketId",
        required: true,
        type: {
          name: "String"
        }
      },
      orderNumber: {
        serializedName: "orderNumber",
        required: true,
        type: {
          name: "Number"
        }
      },
      orderStatus: {
        defaultValue: "PAYMENT_INITIATED",
        isConstant: true,
        serializedName: "orderStatus",
        type: {
          name: "String"
        }
      },
      opayoCheckoutInfo: {
        serializedName: "opayoCheckoutInfo",
        type: {
          name: "Composite",
          className: "OpayoCheckoutInfo"
        }
      }
    }
  }
};

export const OpayoCheckoutInfo: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "OpayoCheckoutInfo",
    modelProperties: {
      txId: {
        serializedName: "txId",
        required: true,
        type: {
          name: "String"
        }
      },
      paymentPageURL: {
        serializedName: "paymentPageURL",
        required: true,
        type: {
          name: "String"
        }
      }
    }
  }
};

export const ApplicantImageUploadResponse: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "ApplicantImageUploadResponse",
    modelProperties: {
      imageResource: {
        serializedName: "imageResource",
        type: {
          name: "String"
        }
      },
      dateUploaded: {
        constraints: {
          Pattern: new RegExp("YYYY-MM-DDThh:mm:ss")
        },
        serializedName: "dateUploaded",
        type: {
          name: "String"
        }
      }
    }
  }
};

export const DDAccountVerifyRequest: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "DDAccountVerifyRequest",
    modelProperties: {
      sortCode: {
        serializedName: "sortCode",
        required: true,
        type: {
          name: "String"
        }
      },
      accountNumber: {
        serializedName: "accountNumber",
        required: true,
        type: {
          name: "String"
        }
      }
    }
  }
};

export const DDAccountVerifyResponse: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "DDAccountVerifyResponse",
    modelProperties: {
      valid: {
        serializedName: "valid",
        required: true,
        type: {
          name: "String"
        }
      },
      bankName: {
        serializedName: "bankName",
        required: true,
        type: {
          name: "String"
        }
      },
      branchName: {
        serializedName: "branchName",
        required: true,
        type: {
          name: "String"
        }
      },
      bankAddress: {
        serializedName: "bankAddress",
        type: {
          name: "Composite",
          className: "Address"
        }
      }
    }
  }
};

export const PostcodeTicketVerifyRequest: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "PostcodeTicketVerifyRequest",
    modelProperties: {
      postCode: {
        serializedName: "postCode",
        required: true,
        type: {
          name: "String"
        }
      },
      ticketID: {
        serializedName: "ticketID",
        required: true,
        type: {
          name: "String"
        }
      },
      applicantDOB: {
        serializedName: "applicantDOB",
        required: true,
        type: {
          name: "String"
        }
      }
    }
  }
};

export const PostcodeTicketVerifyResponse: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "PostcodeTicketVerifyResponse",
    modelProperties: {
      status: {
        serializedName: "status",
        required: true,
        type: {
          name: "String"
        }
      }
    }
  }
};

export const PathsHqj6FyCheckoutV1ApplicantPhotoPostRequestbodyContentMultipartFormDataSchema: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className:
      "PathsHqj6FyCheckoutV1ApplicantPhotoPostRequestbodyContentMultipartFormDataSchema",
    modelProperties: {
      image: {
        serializedName: "image",
        type: {
          name: "Stream"
        }
      }
    }
  }
};

export const CheckoutAPIApplicantImageUploadHeaders: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "CheckoutAPIApplicantImageUploadHeaders",
    modelProperties: {
      basketId: {
        serializedName: "basketid",
        type: {
          name: "String"
        }
      },
      itemId: {
        serializedName: "itemid",
        type: {
          name: "String"
        }
      }
    }
  }
};
